import { useMemo } from 'react';
function getOrCreateDeviceId(storageKey) {
    let id = localStorage.getItem(storageKey) ?? undefined;
    if (id == null) {
        const randomPart = Math.random().toString(36).slice(2);
        id = `${navigator.userAgent}-${randomPart}`;
        localStorage.setItem(storageKey, id);
    }
    return id;
}
export function useDeviceId({ storageKey = 'device.id' } = {}) {
    const deviceId = useMemo(() => getOrCreateDeviceId(storageKey), [storageKey]);
    return deviceId;
}
//# sourceMappingURL=use-device-id.hook.js.map